import { Portal } from "@circle-react-shared/uikit/Portal";
import { useLayoutPartialsContext } from "@circle-react/contexts/layoutPartialsContext";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { ReactNode } from "react";
import { useCallback, useRef } from "react";
import { useClickAway } from "react-use";

import { useLayoutContext } from "@/react/components/SettingsApp/Layout/LayoutContext";
import { SideBar } from "@/react/components/Spaces/Sidebar";

const CLICK_AWAY_EVENTS = ["pointerdown"];

export interface MobileDrawerViewProps {
  isOpen: boolean;
  onClose: () => void;
  renderLeftSidebar?: (() => ReactNode) | null;
}

export const MobileDrawerView = ({
  isOpen,
  onClose,
  renderLeftSidebar,
}: MobileDrawerViewProps) => {
  const { data } = useLayoutPartialsContext();
  const { config: layoutContext } = useLayoutContext();
  const menuRef = useRef<HTMLDivElement>(null);

  const handleClickAway = useCallback(() => {
    if (!isOpen) return;
    onClose();
  }, [isOpen, onClose]);

  useClickAway(menuRef, handleClickAway, CLICK_AWAY_EVENTS);

  const leftSidebarContent =
    renderLeftSidebar ?? layoutContext?.renderLeftSidebar;

  if (!data?.mobile_drawer) {
    return null;
  }

  return (
    <Portal selectorQuery="#react-mobile-drawer-root">
      <div
        ref={menuRef}
        id="menu"
        className={classNames(
          "sidebar",
          "sidebar--mobile",
          "slideout-menu",
          "slideout-menu-left",
          "sidebar--mobile-v2",
        )}
        data-target="mobile-sidebar.menu"
      >
        <div className="sidebar--mobile__content">
          <div className="sidebar--mobile__content__inside">
            {leftSidebarContent ? leftSidebarContent() : <SideBar />}
          </div>
        </div>
      </div>
    </Portal>
  );
};

MobileDrawerView.displayName = "MobileDrawerView";
